import Link from 'next/link'
import { type ReactElement, type ReactNode } from 'react'
import { useSnapshot } from 'valtio'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'

interface QuickLinksCardProps {
  buttonPath: string
  buttonText: string
  icon: ReactNode
  subtitle: string
  title: string
}

export function QuickLinksCard ({ icon, title, subtitle, buttonPath, buttonText }: QuickLinksCardProps): ReactElement {
  const { siteTheme: { buttonColors } } = useSnapshot(proxyGlobalAuth)
  return (
    <div className="flex flex-col bg-white justify-center items-center shadow-lg rounded-sm py-4 px-6 my-6 w-full md:w-80">
      <div className="my-3 w-16 h-16 bg-wpy-light-gray-600 flex justify-center items-center rounded p-3">
        {icon}
      </div>
      <div className="text-wpy-blue-gray-700 text-lg font-semibold mt-3">{title}</div>
      <div className="text-sm text-gray-400 my-2 mx-2 text-center">{subtitle}</div>
      <Link href={buttonPath}>
        <div
          className={`${buttonColors.secondaryClasses} rounded border py-2 px-8 text-sm font-semibold opacity-90 my-2`}
        >
          {buttonText}
        </div>
      </Link>
    </div>
  )
}
